import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {
  CustomSearch,
  CustomTextField,
  EstadoComponente,
  SingleButton,
} from "@/shared/components/ui";
import {
  useUpdateTiketUser,
  usefetchTiketUsers,
} from "@/shared/actions/erp/tiketUsers";
import { useCheckPermissions, useTableFilter } from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import {
  EstadosTiketUserEnum,
  TiketUsers,
} from "@/shared/interfaces";
import { Avatar, Box, Grid, TextField } from "@mui/material";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useForm } from "react-hook-form";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { PermissionsEnum } from "@/auth/interfaces";

const returnUrlTU = "/tikets/usuarios-tikets";

type SaveFormData = {
  observaciones: string;
  motivo_rechazo: string;
};
export default function TiketsUsuariosEnprocesoPagina() {
  useCheckPermissions(PermissionsEnum.api_view_ticketuser);

  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const updateTiketUser = useUpdateTiketUser({navigate, returnUrl:returnUrlTU});
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [idEdit, setIdEdit] = useState<string| null>(null);


  function onActions2(e: MRT_RowData) {
    setIdEdit(e.id_ticketuser);
    setIsModalOpen3(true);
  }
  const columns = useMemo<MRT_ColumnDef<TiketUsers>[]>(
    () => [
      {
        accessorKey: "codigo",
        header: "codigo",
        size: 200,
      },
      {
        accessorKey: "observaciones",
        header: "observaciones",
        size: 200,
      },
      {
        accessorKey: "empresa_data.razon_social",
        header: "empresa",
        size: 200,
      },
      {
        accessorKey: "area_data.nombre",
        header: "area",
        size: 200,
      },
      {
        accessorKey: "estado_ticket",
        header: "estado",
        size: 200,
        Cell: ({ row }) => (
          row.original.estado_ticket != null ?
            <EstadoComponente backgroundColor="black" texto={row.original.estado_ticket || ''} /> : null
        ),
      },
      {
        accessorKey: "imagenes.photosTicket",
        header: "imagen 1",
        size: 200,
        Cell: ({ row }) => {
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              {row.original.imagenes?.photosTicket?.imagen1 && (
                <Avatar
                  sx={{
                    height: 40,
                    width: 40,
                  }}
                  src={row.original.imagenes?.photosTicket?.imagen1.url}
                  alt="imagen 1"
                />
              )}
            </Box>
          );
        },
      },
      {
        accessorKey: "imagenes.photosTicket",
        header: "imagen 1",
        size: 200,
        Cell: ({ row }) => {
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              {row.original.imagenes?.photosTicket?.imagen2 && (
                <Avatar
                  sx={{
                    height: 40,
                    width: 40,
                  }}
                  src={row.original.imagenes?.photosTicket?.imagen2.url}
                  alt="imagen 1"
                />
              )}
            </Box>
          );
        },
      },
      {
        accessorKey: "fecha_creacion",
        header: "fecha creacion	",
        size: 200,
      },
      {
        accessorKey: "departamento_data.nombre",
        header: "departamento",
        size: 200,
      },
      {
        accessorKey: "observaciones",
        header: "observaciones",
        size: 200,
      },
      {
        header: "acciones",
        size: 200,
        Cell: ({ row }) => {
          return (
            <>
              <SingleButton
                label="TERMINAR TICKET"
                variant="text"
                color="success"
                onClick={() => onActions2(row.original)}
                startIcon={<PendingActionsIcon />}
              />

            </>
          );
        },
      },
    ],
    []
  );
  const form = useForm<SaveFormData>();
  const {
    formState: { errors },
    register,
    handleSubmit,
  } = form;

  const onEdit =  handleSubmit((data) => {
    
    if (idEdit) {
      updateTiketUser.mutate(
        {
          id: idEdit!,
          data: {
            estado_ticket: EstadosTiketUserEnum.FINALIZADO,
            observaciones: data.observaciones,
          },
        },
        {
          onSuccess: () => {
            setIsModalOpen3(false);
            setIdEdit(null);
            form.reset({ observaciones: "" });
          },
          onError: (error) => {
            console.error("Error en la mutación", error);
          },
        }
      );
    }
  });
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();

  const { pageIndex } = pagination;

  const {
    isLoading,
    data: TiketUserEnesperaRes,
    isRefetching,
  } = usefetchTiketUsers({
    page: pageIndex + 1,
    nombre_requerimento: searchTerm,
    estado_ticket: EstadosTiketUserEnum.EN_PROCESO,
  });
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CustomSearch
          onChange={onChangeFilter}
          value={globalFilter}
          text=""
        />
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<TiketUsers>
          columns={columns}
          data={TiketUserEnesperaRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={TiketUserEnesperaRes?.data?.count}
          // // actions
          canDelete={false}
          // crud
          enableColumnActions={false}
          enableEditing={false}
          positionActionsColumn="first"
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Detalles"
        cancelTextBtn="Cerrar"
        onClose={() => setIsModalOpen(false)}
        minWidth="80%"
        contentNode={
          <>
            <Grid container spacing={3}>
              <CustomTextField
                label="observaciones"
                name="observaciones"
                control={form.control}
                defaultValue={form.getValues().observaciones || ""}
                error={errors.observaciones}
                helperText={errors.observaciones?.message ?? ""}
              />
            </Grid>
          </>
        }
      />
      <ScrollableDialogProps
        open={isModalOpen3}
        title="Observacion de aprobacion de ticket"
        confirmTextBtn="Aprobar"
        contentNode={
          <>
            <TextField
  {...register("observaciones", { required: "La observacion es obligatoria" })}
  id="observaciones"
  label="Observación"
  fullWidth
  rows={4}
  multiline
  error={Boolean(errors.observaciones)}
  helperText={errors.observaciones?.message}
/>
          </>
        }
        onConfirm={onEdit}
        onClose={() => setIsModalOpen3(false)}
      />
    </Grid>
  );
}
